<ng-content></ng-content>
<span
    *ngIf="loaderShow"
    class="loaderx iconsax"
    iconName="refresh"></span>
